import ArrayHelper from "../helpers/array-helper";

class MobileNavigationLanguage {
    constructor(layoutsContainer) {
        this.consts = {
            subnavIdAttr: 'data-subnav-id'
        };

        this.container= document.getElementsByClassName('layout-nav-mobile-container')[0];

        if (!this.container) {
            console.warn('layout-nav-mobile-container not found. Mobile menu is not loaded');

            return;
        }

        this.submenus = new Map();
        this.layoutsContainer = layoutsContainer;
        this.navigationContainer = this.container.querySelector('ul.layout-nav-mobile');
        this.mainnavContainer = this.container.querySelector('.layout-nav-mobile-level-container.level-one');
        this.submenusContainer = this.container.querySelector('.layout-nav-mobile-level-container.level-two');
        this.arrowIcon = IconHelper.getSvgHref('icon-arrow-right');

        this.header = null;
        this.mainnavHeader = null;
        this.submenusHeader = null;
  
        this.init();
    }

    init() {
        this.loadHeaders();
        this.loadLinks();
        this.loadAdditionalButtons();
        this.attachEvents();
    }

    loadHeaders() {
        this.header = this.container.getElementsByClassName('layout-nav-mobile-header')[0];

        if (!this.header) {
            return;
        }

        // If there is no search wisget in the header remove the search widget container in the mobile menu
        var searchWrapper = document.body.querySelector('.header-one .search-wrapper');

        if (searchWrapper.children && searchWrapper.children.length > 0) {
            DomHelper.addClass('has-search', this.container);
        } else {
            var searchBoxContainer = this.header.getElementsByClassName('layout-nav-mobile-header-search-container')[0];

            if (searchBoxContainer) {
                DomHelper.removeElement(searchBoxContainer);
            }
        }

        var html = this.header.outerHTML;

        this.mainnavContainer.insertAdjacentHTML('afterbegin', html);
        this.mainnavHeader = this.mainnavContainer.firstElementChild;
        DomHelper.addClass('mainnav-header', this.mainnavHeader);

        this.submenusContainer.insertAdjacentHTML('afterbegin', html);
        this.submenusHeader = this.submenusContainer.firstElementChild;
        DomHelper.addClass('submenus-header', this.submenusHeader);
    } 

    loadLinks() {
        this.submenus.clear();

        var layouts = Array.prototype.slice.call(this.layoutsContainer.getElementsByClassName('navItemLayout'));
        layouts.forEach((layout) => {
            this.loadParentLinks(layout); 
        });
    }

    loadParentLinks(layout) {
        var parentAnchor = layout.parentNode.querySelector('a');

        if (!parentAnchor) {
            return;
        }

        var parentLink = MobileNavigationLanguage.createMenuItemFromAnchor(parentAnchor, this.navigationContainer, ['nav-title']);
        var layoutContent = layout.getElementsByClassName('navDropdown')[0];

        if (!(layoutContent && layoutContent.childNodes && layoutContent.childNodes.length > 0)) {
            return; 
        }

        var hasAnchors = layoutContent.getElementsByTagName('a')[0];

        if (!hasAnchors) {
            return;
        }

        var sublayouts = Array.prototype.slice.call(layoutContent.getElementsByClassName('navLevelTwoLayout'));

        if (sublayouts.length > 0) {
            var defaultSubLayoutFound = false;

            sublayouts.forEach((sublayout) => {
                var subAnchor = sublayout.querySelector('.navLevelTwoLink a');

                if (subAnchor) {
                    var submenuItem = MobileNavigationLanguage.createMenuItemFromAnchor(subAnchor, this.navigationContainer); 

                    if (LayoutNavigationHelper.sublayoutHasContent(sublayout)) {    
                        var sublayoutContent = sublayout.getElementsByClassName('navLevelTwoDropdown')[0];                               
                        this.loadSubmenu(submenuItem, sublayoutContent);
                    }
                } else if (!defaultSubLayoutFound && LayoutNavigationHelper.sublayoutHasContent(sublayout)) {
                        defaultSubLayoutFound = true;
                        var sublayoutContent = sublayout.getElementsByClassName('navLevelTwoDropdown')[0]; 
                        this.loadSubmenu(parentLink, sublayoutContent);
                }
            });

            return;
        } 

        var navLevelTwoLayout = layoutContent.getElementsByClassName('menuLevelTwoLayout')[0];
        
        if (navLevelTwoLayout) {          
            this.loadSubmenu(parentLink, navLevelTwoLayout);

            return;
        }

        this.loadSubmenu(parentLink, layoutContent);
    }

    loadSubmenu(parentLink, sublayout) {
        var allAnchors = Array.prototype.slice.call(sublayout.getElementsByTagName('a'));

        if (allAnchors.length == 0) {
            return;
        }

        this.addArrowIcon(parentLink);
        DomHelper.addClass('has-submmenu', parentLink);
        parentLink.addEventListener('click', (ev) => { ev.preventDefault(); });

        var subnavId = `subnav-${GUIDHelper.get()}`;
        parentLink.setAttribute(this.consts.subnavIdAttr, subnavId);

        var html = `<ul class="layout-nav-mobile-submenu" ${this.consts.subnavIdAttr}="${subnavId}"></ul>`;
        this.submenusContainer.insertAdjacentHTML('beforeend', html);
        var submenu = this.submenusContainer.lastElementChild;
        submenu.setAttribute(this.consts.subnavIdAttr, subnavId);
        this.submenus.set(subnavId, submenu);

        var navigations = Array.prototype.slice.call(sublayout.getElementsByClassName('nav-vertical-list'));
        navigations.forEach((navigation) => {
            var items = Array.prototype.slice.call(navigation.getElementsByTagName('li'));

            for (var i =0; i < items.length; i++) {
                var item = items[i];
                var anchor = item.getElementsByTagName('a')[0];

                if (anchor) {
                    var submenuItem = MobileNavigationLanguage.createMenuItemFromAnchor(anchor, submenu);

                    if (i === 0 && DomHelper.hasClass('nav-vertical-list__has-title', navigation)) {
                        DomHelper.addClass('nav-title', submenuItem);
                    }

                    if (DomHelper.hasClass('nav-vertical-list__arrows-big', navigation)) {
                        DomHelper.addClasses(['nav-title', 'submenu-title'], submenuItem);
                    }

                    ArrayHelper.removeWhere(allAnchors, (arrItem) => arrItem === anchor);
                }
            }
        });

        allAnchors.forEach((anchor) => {
            MobileNavigationLanguage.createMenuItemFromAnchor(anchor, submenu, ['nav-title']);
        });
    }  

    addArrowIcon(menuItem) {
        var anchor = menuItem.getElementsByTagName('a')[0].parentNode;
        var svgSpan = `<span>${this.arrowIcon}</span>`;
        anchor.insertAdjacentHTML('beforeend', svgSpan);
    }

    loadAdditionalButtons() {
        var footerHtml = '<div class="layout-nav-mobile-footer"></div>';
        this.mainnavContainer.insertAdjacentHTML('beforeend', footerHtml);
        var footer = this.mainnavContainer.lastElementChild;

        var loginLinkWrapper = document.getElementsByClassName('login-link-wrapper')[0];

        if (loginLinkWrapper) {
            var loginLinkWrapperHtml = loginLinkWrapper.innerHTML;

            if (loginLinkWrapperHtml) {
                footer.insertAdjacentHTML('beforeend', loginLinkWrapperHtml);
            } 
        }

        var langSelectorWrapper = document.getElementsByClassName('language-selector-wrapper')[0];

        if (langSelectorWrapper) {
            var langSelectorWrapperHtml = langSelectorWrapper.innerHTML;

            if (langSelectorWrapperHtml) {
                footer.insertAdjacentHTML('beforeend', langSelectorWrapperHtml);
            } 
        }
    }

    attachEvents() {
        this.header.addEventListener('click', (ev) => {
            let el = DomHelper.getClickTarget(ev);

            do {
                if (el === this.header) {
                    return false;
                } else if (DomHelper.hasClass('btn-mobile-menu', el)) {
                    this.openMobileMenu();

                    return false;
                } else if (DomHelper.hasClass('btn-search-mobile', el)){
                    this.openMobileMenu();
                    let searchInput = document.querySelector('.nav-one .ui-search input');
                    
                    setTimeout(function () {
                        searchInput.focus();
                    }, 600)

                    return false;
                }
                el = el.parentNode;
            } while (el);
        });

        this.mainnavHeader.addEventListener('click', (ev) => {
            let el = DomHelper.getClickTarget(ev);

            do {
                if (el === this.mainnavHeader) {
                    return false;
                } else if (DomHelper.hasClass('btn-close', el)) {
                    this.closeMobileMenu();

                    return false;
                }
                el = el.parentNode;
            } while (el);
        });

        this.submenusHeader.addEventListener('click', (ev) => {
            let el = DomHelper.getClickTarget(ev);

            do {
                if (el === this.mainnavHeader) {
                    return false;
                } else if (DomHelper.hasClass('btn-back', el)) {
                    this.processSubmenus();

                    return false;
                } else if (DomHelper.hasClass('btn-close', el)) {
                    this.closeMobileMenu();
                    this.processSubmenus();

                    return false;
                }
                el = el.parentNode;
            } while (el);
        });

        this.navigationContainer.addEventListener('click', (ev) => {
            let el = DomHelper.getClickTarget(ev);
            let menuLink = DomHelper.closest(el, '.has-submmenu', this.navigationContainer);
  
            if (menuLink) {
                var subnavId = menuLink.getAttribute(this.consts.subnavIdAttr);
                this.processSubmenus(subnavId);
            }
        });
    }

    openMobileMenu() {
        DomHelper.addClass('open', this.mainnavContainer);
        DomHelper.addClasses(['mobile-nav-open', 'mobile-nav-open__level-one'],  document.body);

        setTimeout(() => {
            DomHelper.addClass('mobile-nav-sticky-header',  document.body);
        }, 400);
    }

    closeMobileMenu() {
        DomHelper.removeClass('open', this.mainnavContainer);
        DomHelper.removeClass('mobile-nav-sticky-header',  document.body);

        setTimeout(() => {
            DomHelper.removeClasses(['mobile-nav-open', 'mobile-nav-open__level-one'],  document.body);
        }, 400);
    }
  
    processSubmenus(openSubmenuId) {
        var hasOpenSubmenu = false;

        this.submenus.forEach((submenu, id, map) => {
            if (openSubmenuId && id == openSubmenuId) {
                DomHelper.addClass('submenu-open', submenu);
                hasOpenSubmenu = true;
            } else {
                DomHelper.removeClass('submenu-open', submenu);
            }
        });

        if (hasOpenSubmenu) {
            DomHelper.addClass('open', this.submenusContainer);
            DomHelper.addClass('mobile-nav-open__level-two',  document.body);
        } else {
            DomHelper.removeClass('open', this.submenusContainer);

            setTimeout(() => {
                DomHelper.removeClass('mobile-nav-open__level-two',  document.body);
            }, 400);
        }
    }

    static createMenuItemFromAnchor(anchor, menuItemsContainer, cssClasses) {
        var href = anchor.getAttribute('href');
        var target = anchor.getAttribute('target');
        var text = anchor.text;

        var hrefT = !!href ? ` href="${href}"` : ' href="#"';
        var targetT = !!target ? ` target="${target}"` : '';

        var html = `<li><a${hrefT}${targetT}">${text}</a></li>`;
        menuItemsContainer.insertAdjacentHTML('beforeend', html);
        var menuItem = menuItemsContainer.lastElementChild;

        if (cssClasses) {
            cssClasses.forEach((cssClass) => {
                DomHelper.addClass(cssClass, menuItem);
            });
        }

        return menuItem;
    }
}

export default MobileNavigationLanguage;